import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";



export const EResourcesAvailabilityClientManager = (function( $ ) {
	var getDownloadableItemAvailability_util = function( options ) {
		options.downloadableResources = options.downloadableResources || [];
		options.resources = options.resources || [];

		if( ApplicationData.locationConfiguration.useThirdPartyEResourceAvailability() === false ) {
			if( options.callback ) {
				options.callback( options.resources, options.wentToServer, true );
				return;
			}
		}

		var eResourceIds = [],
			eAvailabilityCallSuccess = false,
			eAvailabilityWentToServer = false,
			finalWentToServer = false,
			finalCallSuccess = false;

		if( options.downloadableResources.length > 0 ) {
			$.each( options.downloadableResources, function( index, eResource ) {
				// Batch Ids for rest call
				var bibId = "";
				if( eResource.hostBibliographicId !== null && eResource.hostBibliographicId !== undefined ) {
					bibId = eResource.hostBibliographicId;
				} else {
					bibId = eResource.bibliographicId;
				}

				eResourceIds.push( {
					hostBibliographicId:        bibId,
					useLoggedInUserCredentials: false
				} );
			} );

			var myCallback = function( eResourceAvailabilities ) {
				TLCLogger.log( "eResourceAvailabilityReturn:", eResourceAvailabilities );
				try {
					// Iterate availability return
					$.each( eResourceAvailabilities, function( availabilityIndex, eResourceAvailability ) {
						// Iterate each resource
						$.each( options.resources, function( resourceIndex, resource ) {
							// Compare bibIDs
							if( resource.hostBibliographicId == eResourceAvailability.hostBibliographicId || resource.bibliographicId == eResourceAvailability.hostBibliographicId ) {
								// Iterate each source
								resource.eAvailabilities = eResourceAvailability.availabilitySources;

								TLCLogger.log( resource.eAvailabilities );

								// TODO: create cache
								//								createAvailabilityCache(itemAvailability.itemIdentifier, itemAvailability, currentTimestamp);
							}
						} );
					} );
					eAvailabilityCallSuccess = true;
					eAvailabilityWentToServer = true;
				} catch( badThings ) {
					TLCLogger.log( badThings );
				}
			};

			TLCRest.jsonCall( LS2PAC_CONSTANTS.restUrls.eResourceAvailability, {
				callback:       myCallback,
				finallyHandler: function() {
					// callSuccess --- Availability
					// eAvailabilityCallSuccess --- eAvailability

					// finalCallSuccess === false right now
					// If 1 resource, downloadable --- rely on eAvailabilityCallSuccess
					// If 1 resource, nonDownload --- never gets here
					// If multiple resources, wentToServer is true, and it got here (there ARE downloadable resources)
					//      - then both must be true to set to true

					if( options.throwResponseEvent ) {
						TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onGetEResourceAvailabilityResponse, options.resources );
					}

					if( options.wentToServer ) {
						if( options.callSuccess && eAvailabilityCallSuccess ) {
							finalCallSuccess = true;
						}
						finalWentToServer = true;
					} else {
						finalCallSuccess = eAvailabilityCallSuccess;
						finalWentToServer = eAvailabilityWentToServer;
					}

					if( options.callback ) {
						options.callback( options.resources, finalWentToServer, finalCallSuccess )
					}
				},
				timeout:        60000,
				postData:       eResourceIds,
				cancellable:    options.callCanAbort
			} );
		}
	};

	return {
		getDownloadableItemAvailability: function( options ) {
			getDownloadableItemAvailability_util( options );
		}
	}
})( jQuery );
